import { render } from "./Sounds.vue?vue&type=template&id=16ae03fd&scoped=true"
import script from "./Sounds.vue?vue&type=script&lang=js"
export * from "./Sounds.vue?vue&type=script&lang=js"

import "./Sounds.vue?vue&type=style&index=0&id=16ae03fd&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16ae03fd"]])

export default __exports__